// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}/*
! tailwindcss v3.4.18 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */
  -moz-tab-size: 4; /* 3 */
  -o-tab-size: 4;
     tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}
  input,
  textarea,
  select {
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity, 1));
}

  a {
  --tw-text-opacity: 1;
  color: rgb(7 89 133 / var(--tw-text-opacity, 1));
}

  a:hover {
  --tw-text-opacity: 1;
  color: rgb(7 89 133 / var(--tw-text-opacity, 1));
  text-decoration-line: underline;
}
.form-input,.form-textarea,.form-select,.form-multiselect {
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  background-color: #fff;
  border-color: #6b7280;
  border-width: 1px;
  border-radius: 0px;
  padding-top: 0.5rem;
  padding-right: 0.75rem;
  padding-bottom: 0.5rem;
  padding-left: 0.75rem;
  font-size: 1rem;
  line-height: 1.5rem;
  --tw-shadow: 0 0 #0000;
}
.form-input:focus, .form-textarea:focus, .form-select:focus, .form-multiselect:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
  --tw-ring-inset: var(--tw-empty,/*!*/ /*!*/);
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: #2563eb;
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  border-color: #2563eb;
}
.form-input::-moz-placeholder, .form-textarea::-moz-placeholder {
  color: #6b7280;
  opacity: 1;
}
.form-input::placeholder,.form-textarea::placeholder {
  color: #6b7280;
  opacity: 1;
}
.form-input::-webkit-datetime-edit-fields-wrapper {
  padding: 0;
}
.form-input::-webkit-date-and-time-value {
  min-height: 1.5em;
  text-align: inherit;
}
.form-input::-webkit-datetime-edit {
  display: inline-flex;
}
.form-input::-webkit-datetime-edit,.form-input::-webkit-datetime-edit-year-field,.form-input::-webkit-datetime-edit-month-field,.form-input::-webkit-datetime-edit-day-field,.form-input::-webkit-datetime-edit-hour-field,.form-input::-webkit-datetime-edit-minute-field,.form-input::-webkit-datetime-edit-second-field,.form-input::-webkit-datetime-edit-millisecond-field,.form-input::-webkit-datetime-edit-meridiem-field {
  padding-top: 0;
  padding-bottom: 0;
}
/* Override the blue set by @tailwindcss/forms */
.form-input:focus,
  .form-textarea:focus,
  .form-select:focus,
  .form-multiselect:focus {
    --tw-ring-color: var(--btn-primary-bg);
    border-color: var(--btn-primary-bg);
  }
.bg-panel {
    background-color: var(--panel-bg);
    color: var(--panel-text);
  }
.btn {
  display: inline-block;
  padding: 0.5rem;
  font-weight: 700;
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-duration: 150ms;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    background-color: var(--btn-primary-bg);
    color: var(--btn-primary-text);
    border-radius: var(--btn-border-radius);
}
.btn:hover,
    .btn.hover {
      background-color: var(--btn-primary-bg-hover);
    }
.btn-secondary {
  display: inline-block;
  padding: 0.5rem;
  font-weight: 700;
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-duration: 150ms;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    background-color: var(--btn-primary-bg);
    color: var(--btn-primary-text);
    border-radius: var(--btn-border-radius);
}
.btn-secondary:hover,.btn-secondary.hover {
      background-color: var(--btn-primary-bg-hover);
    }
.btn-secondary {
    background-color: var(--btn-secondary-bg);
    color: var(--btn-secondary-text);
  }
.btn-secondary:hover,
    .btn-secondary.hover {
      background-color: var(--btn-secondary-bg-hover);
    }
.btn-secondary.active {
      background-color: var(--btn-primary-bg);
    }
.btn-rounded {
  border-radius: 9999px;
}
/* For the send button in ChatPanel */
.btn-in-input {
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity, 1));
}
.btn-in-input:hover {
      color: var(--btn-primary-bg-hover);
    }
.btn-in-input[disabled],
    .btn-in-input[disabled]:hover {
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity, 1));
}
.animation-ping {
    animation: ping 1s cubic-bezier(0, 0, 0.2, 1) infinite;
  }
@keyframes ping {
    75%,
    100% {
      transform: scale(2);
      opacity: 0;
    }
  }
.counter {
  position: absolute;
  right: -0.5rem;
  bottom: 0px;
  display: flex;
  height: 1.5rem;
  width: 1.5rem;
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
  align-items: center;
  justify-content: center;
  border-radius: 9999px;
  border-width: 2px;
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity, 1));
  font-size: 0.875rem;
  line-height: 1.25rem;
    background-color: var(--btn-secondary-bg);
    color: var(--btn-secondary-text);
}
.counter-red {
  position: absolute;
  right: -0.5rem;
  bottom: 0px;
  display: flex;
  height: 1.5rem;
  width: 1.5rem;
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
  align-items: center;
  justify-content: center;
  border-radius: 9999px;
  border-width: 2px;
  border-color: rgb(209 213 219 / var(--tw-border-opacity, 1));
  font-size: 0.875rem;
  line-height: 1.25rem;
    background-color: var(--btn-secondary-bg);
    color: var(--btn-secondary-text);
    --tw-border-opacity: 1;
    border-color: rgb(220 38 38 / var(--tw-border-opacity, 1));
    --tw-bg-opacity: 1;
    background-color: rgb(220 38 38 / var(--tw-bg-opacity, 1));
    --tw-text-opacity: 1;
    color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.naf-centered-fullscreen {
    background-color: var(--panel-bg);
    color: var(--panel-text);
    position: absolute;
    inset: 0px;
    z-index: 10;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
  }
.naf-bar {
  pointer-events: none;
  position: absolute;
  z-index: 10;
  display: flex;
  width: 100%;
  align-items: center;
  gap: 1rem;
}
.naf-bar>* {
  pointer-events: auto;
}
.naf-top-bar-left {
  pointer-events: none;
  position: absolute;
  z-index: 10;
  display: flex;
  width: 100%;
  align-items: center;
  gap: 1rem;
}
.naf-top-bar-left>* {
  pointer-events: auto;
}
.naf-top-bar-left {
  left: 1.5rem;
  top: 1.5rem;
  justify-content: flex-start;
}
.naf-top-bar-center {
  pointer-events: none;
  position: absolute;
  z-index: 10;
  display: flex;
  width: 100%;
  align-items: center;
  gap: 1rem;
}
.naf-top-bar-center>* {
  pointer-events: auto;
}
.naf-top-bar-center {
  top: 1.5rem;
  justify-content: center;
}
.naf-top-bar-right {
  pointer-events: none;
  position: absolute;
  z-index: 10;
  display: flex;
  width: 100%;
  align-items: center;
  gap: 1rem;
}
.naf-top-bar-right>* {
  pointer-events: auto;
}
.naf-top-bar-right {
  right: 1.5rem;
  top: 1.5rem;
  justify-content: flex-end;
}
.naf-bottom-bar-left {
  pointer-events: none;
  position: absolute;
  z-index: 10;
  display: flex;
  width: 100%;
  align-items: center;
  gap: 1rem;
}
.naf-bottom-bar-left>* {
  pointer-events: auto;
}
.naf-bottom-bar-left {
  bottom: 1.5rem;
  left: 1.5rem;
  justify-content: flex-start;
}
.naf-bottom-bar-center {
  pointer-events: none;
  position: absolute;
  z-index: 10;
  display: flex;
  width: 100%;
  align-items: center;
  gap: 1rem;
}
.naf-bottom-bar-center>* {
  pointer-events: auto;
}
.naf-bottom-bar-center {
  bottom: 1.5rem;
  justify-content: center;
}
.naf-bottom-bar-right {
  pointer-events: none;
  position: absolute;
  z-index: 10;
  display: flex;
  width: 100%;
  align-items: center;
  gap: 1rem;
}
.naf-bottom-bar-right>* {
  pointer-events: auto;
}
.naf-bottom-bar-right {
  bottom: 1.5rem;
  right: 1.5rem;
  justify-content: flex-end;
}
.pointer-events-auto {
  pointer-events: auto;
}
.visible {
  visibility: visible;
}
.invisible {
  visibility: hidden;
}
.fixed {
  position: fixed;
}
.absolute {
  position: absolute;
}
.relative {
  position: relative;
}
.sticky {
  position: sticky;
}
.bottom-14 {
  bottom: 3.5rem;
}
.bottom-16 {
  bottom: 4rem;
}
.left-2 {
  left: 0.5rem;
}
.right-0 {
  right: 0px;
}
.right-2 {
  right: 0.5rem;
}
.top-16 {
  top: 4rem;
}
.z-10 {
  z-index: 10;
}
.z-20 {
  z-index: 20;
}
.mb-2 {
  margin-bottom: 0.5rem;
}
.mb-3 {
  margin-bottom: 0.75rem;
}
.mr-2 {
  margin-right: 0.5rem;
}
.mt-3 {
  margin-top: 0.75rem;
}
.block {
  display: block;
}
.flex {
  display: flex;
}
.grid {
  display: grid;
}
.hidden {
  display: none;
}
.h-7 {
  height: 1.75rem;
}
.h-full {
  height: 100%;
}
.w-7 {
  width: 1.75rem;
}
.w-full {
  width: 100%;
}
.min-w-\\[100px\\] {
  min-width: 100px;
}
.max-w-full {
  max-width: 100%;
}
.shrink {
  flex-shrink: 1;
}
.grow {
  flex-grow: 1;
}
.transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.resize-none {
  resize: none;
}
.resize {
  resize: both;
}
.flex-row {
  flex-direction: row;
}
.flex-col {
  flex-direction: column;
}
.items-start {
  align-items: flex-start;
}
.items-end {
  align-items: flex-end;
}
.items-center {
  align-items: center;
}
.justify-end {
  justify-content: flex-end;
}
.justify-center {
  justify-content: center;
}
.justify-between {
  justify-content: space-between;
}
.gap-2 {
  gap: 0.5rem;
}
.space-x-1 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.25rem * var(--tw-space-x-reverse));
  margin-left: calc(0.25rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.5rem * var(--tw-space-x-reverse));
  margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-y-4 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}
.overflow-y-auto {
  overflow-y: auto;
}
.whitespace-pre-wrap {
  white-space: pre-wrap;
}
.rounded-lg {
  border-radius: 0.5rem;
}
.rounded-xl {
  border-radius: 0.75rem;
}
.bg-gray-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity, 1));
}
.bg-neutral-800 {
  --tw-bg-opacity: 1;
  background-color: rgb(38 38 38 / var(--tw-bg-opacity, 1));
}
.bg-sky-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(186 230 253 / var(--tw-bg-opacity, 1));
}
.bg-teal-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(15 118 110 / var(--tw-bg-opacity, 1));
}
.bg-teal-800 {
  --tw-bg-opacity: 1;
  background-color: rgb(17 94 89 / var(--tw-bg-opacity, 1));
}
.p-2 {
  padding: 0.5rem;
}
.p-4 {
  padding: 1rem;
}
.px-1 {
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.pb-2 {
  padding-bottom: 0.5rem;
}
.pr-10 {
  padding-right: 2.5rem;
}
.pr-4 {
  padding-right: 1rem;
}
.text-center {
  text-align: center;
}
.text-base {
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.font-bold {
  font-weight: 700;
}
.font-medium {
  font-weight: 500;
}
.font-normal {
  font-weight: 400;
}
.uppercase {
  text-transform: uppercase;
}
.text-gray-900 {
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity, 1));
}
.text-red-600 {
  --tw-text-opacity: 1;
  color: rgb(220 38 38 / var(--tw-text-opacity, 1));
}
.text-slate-200 {
  --tw-text-opacity: 1;
  color: rgb(226 232 240 / var(--tw-text-opacity, 1));
}
.shadow {
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-lg {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.ring {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-1 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-black {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(0 0 0 / var(--tw-ring-opacity, 1));
}
.ring-opacity-5 {
  --tw-ring-opacity: 0.05;
}
.blur {
  --tw-blur: blur(8px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.transition {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.ease-out {
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}
:root {
  --panel-bg: rgb(0 0 0); /* bg-slate-400 */
  --panel-text: rgb(255 255 255); /* bg-neutral-800 */
  --btn-primary-bg: rgb(85, 252, 39); /* bg-slate-600 */
  --btn-primary-bg-hover: rgb(0 0 0); /* bg-slate-700 */
  --btn-primary-text: rgb(100 100 100); /* text-slate-200 */
  --btn-secondary-bg: rgb(38 38 38); /* bg-neutral-800 */
  --btn-secondary-bg-hover: rgb(64 64 64); /* bg-neutral-600 */
  --btn-secondary-text: rgb(255 255 255); /* text-slate-300 */
  --btn-border-radius: 0.5rem; /* rounded-lg */
}
@media (min-width: 640px) {

  .sm\\:left-auto {
    left: auto;
  }

  .sm\\:w-screen {
    width: 100vw;
  }

  .sm\\:max-w-sm {
    max-width: 24rem;
  }
}
`, "",{"version":3,"sources":["webpack://./node_modules/tailwindcss/base.css","webpack://./node_modules/tailwindcss/components.css","webpack://./src/assets/style.css","webpack://./node_modules/tailwindcss/utilities.css","webpack://./src/assets/colors.css"],"names":[],"mappings":"AAAA;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc,CAAd;;CAAc,CAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;;CAAc;;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gBAAc,EAAd,MAAc;EAAd,cAAc;KAAd,WAAc,EAAd,MAAc;EAAd,+HAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,yCAAc;UAAd,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;AAAd;EAAA,aAAc;AAAA;EAAd;;;EAAA,oBAAc;EAAd;AAAc;;EAAd;EAAA,oBAAc;EAAd;AAAc;;EAAd;EAAA,oBAAc;EAAd,gDAAc;EAAd;AAAc;ACAd;EAAA,wBAAoB;KAApB,qBAAoB;UAApB,gBAAoB;EAApB,sBAAoB;EAApB,qBAAoB;EAApB,iBAAoB;EAApB,kBAAoB;EAApB,mBAAoB;EAApB,sBAAoB;EAApB,sBAAoB;EAApB,qBAAoB;EAApB,eAAoB;EAApB,mBAAoB;EAApB,sBAAoB;AAAA;AAApB;EAAA,8BAAoB;EAApB,mBAAoB;EAApB,4CAAoB;EAApB,2BAAoB;EAApB,4BAAoB;EAApB,wBAAoB;EAApB,2GAAoB;EAApB,yGAAoB;EAApB,iFAAoB;EAApB;AAAoB;AAApB;EAAA,cAAoB;EAApB;AAAoB;AAApB;EAAA,cAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,iBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,cAAoB;EAApB;AAAoB;ACsBlB,gDAAgD;AAChD;;;;IAIE,sCAAsC;IACtC,mCAAmC;EACrC;AAYA;IACE,iCAAiC;IACjC,wBAAwB;EAC1B;AAGE;EAAA,qBAA+E;EAA/E,eAA+E;EAA/E,gBAA+E;EAA/E,6EAA+E;EAA/E,iGAA+E;EAA/E,uGAA+E;EAA/E,wJAA+E;EAA/E,0BAA+E;EAA/E,wDAA+E;IAC/E,uCAAuC;IACvC,8BAA8B;IAC9B;AAH+E;AAK/E;;MAEE,6CAA6C;IAC/C;AAIA;EAAA,qBAAU;EAAV,eAAU;EAAV,gBAAU;EAAV,6EAAU;EAAV,iGAAU;EAAV,uGAAU;EAAV,wJAAU;EAAV,0BAAU;EAAV,wDAAU;IAAV,uCAAU;IAAV,8BAAU;IAAV;AAAU;AAAV;MAAA,6CAAU;IAAA;AADZ;IAEE,yCAAyC;IACzC,gCAAgC;EAUlC;AARE;;MAEE,+CAA+C;IACjD;AAEA;MACE,uCAAuC;IACzC;AAIA;EAAA;AAAmB;AAGrB,qCAAqC;AAEnC;EAAA,oBAAoB;EAApB;AAAoB;AACpB;MACE,kCAAkC;IACpC;AAGE;;EAAA,oBAAoB;EAApB;AAAoB;AAIxB;IACE,sDAAsD;EACxD;AAEA;IACE;;MAEE,mBAAmB;MACnB,UAAU;IACZ;EACF;AAGE;EAAA,kBAAoI;EAApI,cAAoI;EAApI,WAAoI;EAApI,aAAoI;EAApI,cAAoI;EAApI,aAAoI;EAApI,yBAAoI;KAApI,sBAAoI;UAApI,iBAAoI;EAApI,mBAAoI;EAApI,uBAAoI;EAApI,qBAAoI;EAApI,iBAAoI;EAApI,sBAAoI;EAApI,4DAAoI;EAApI,mBAAoI;EAApI,oBAAoI;IACpI,yCAAyC;IACzC;AAFoI;AAMpI;EAAA,kBAAmD;EAAnD,cAAmD;EAAnD,WAAmD;EAAnD,aAAmD;EAAnD,cAAmD;EAAnD,aAAmD;EAAnD,yBAAmD;KAAnD,sBAAmD;UAAnD,iBAAmD;EAAnD,mBAAmD;EAAnD,uBAAmD;EAAnD,qBAAmD;EAAnD,iBAAmD;EAAnD,4DAAmD;EAAnD,mBAAmD;EAAnD,oBAAmD;IAAnD,yCAAmD;IAAnD,gCAAmD;IAAnD,sBAAmD;IAAnD,0DAAmD;IAAnD,kBAAmD;IAAnD,0DAAmD;IAAnD,oBAAmD;IAAnD;AAAmD;AAInD;IAAA,iCAAqF;IAArF,wBAAqF;IAArF,kBAAqF;IAArF,UAAqF;IAArF,WAAqF;IAArF,aAAqF;IAArF,sBAAqF;IAArF,mBAAqF;IAArF,uBAAqF;IAArF,WAAqF;EAAA;AAIrF;EAAA,oBAAiG;EAAjG,kBAAiG;EAAjG,WAAiG;EAAjG,aAAiG;EAAjG,WAAiG;EAAjG,mBAAiG;EAAjG;AAAiG;AAAjG;EAAA;AAAiG;AAIjG;EAAA,oBAAyC;EAAzC,kBAAyC;EAAzC,WAAyC;EAAzC,aAAyC;EAAzC,WAAyC;EAAzC,mBAAyC;EAAzC;AAAyC;AAAzC;EAAA;AAAyC;AAAzC;EAAA,YAAyC;EAAzC,WAAyC;EAAzC;AAAyC;AAIzC;EAAA,oBAAmC;EAAnC,kBAAmC;EAAnC,WAAmC;EAAnC,aAAmC;EAAnC,WAAmC;EAAnC,mBAAmC;EAAnC;AAAmC;AAAnC;EAAA;AAAmC;AAAnC;EAAA,WAAmC;EAAnC;AAAmC;AAInC;EAAA,oBAAwC;EAAxC,kBAAwC;EAAxC,WAAwC;EAAxC,aAAwC;EAAxC,WAAwC;EAAxC,mBAAwC;EAAxC;AAAwC;AAAxC;EAAA;AAAwC;AAAxC;EAAA,aAAwC;EAAxC,WAAwC;EAAxC;AAAwC;AAIxC;EAAA,oBAA4C;EAA5C,kBAA4C;EAA5C,WAA4C;EAA5C,aAA4C;EAA5C,WAA4C;EAA5C,mBAA4C;EAA5C;AAA4C;AAA5C;EAAA;AAA4C;AAA5C;EAAA,cAA4C;EAA5C,YAA4C;EAA5C;AAA4C;AAI5C;EAAA,oBAAsC;EAAtC,kBAAsC;EAAtC,WAAsC;EAAtC,aAAsC;EAAtC,WAAsC;EAAtC,mBAAsC;EAAtC;AAAsC;AAAtC;EAAA;AAAsC;AAAtC;EAAA,cAAsC;EAAtC;AAAsC;AAItC;EAAA,oBAA2C;EAA3C,kBAA2C;EAA3C,WAA2C;EAA3C,aAA2C;EAA3C,WAA2C;EAA3C,mBAA2C;EAA3C;AAA2C;AAA3C;EAAA;AAA2C;AAA3C;EAAA,cAA2C;EAA3C,aAA2C;EAA3C;AAA2C;AC5I/C;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,8FAAmB;EAAnB;AAAmB;AAAnB;EAAA,+EAAmB;EAAnB,mGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,wJAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;ACAnB;EACE,sBAAsB,EAAE,iBAAiB;EACzC,8BAA8B,EAAE,mBAAmB;EACnD,kCAAkC,EAAE,iBAAiB;EACrD,kCAAkC,EAAE,iBAAiB;EACrD,oCAAoC,EAAE,mBAAmB;EACzD,iCAAiC,EAAE,mBAAmB;EACtD,uCAAuC,EAAE,mBAAmB;EAC5D,sCAAsC,EAAE,mBAAmB;EAC3D,2BAA2B,EAAE,eAAe;AAC9C;AFVA;;EAAA;IAAA;EA+IA;;EA/IA;IAAA;EA+IA;;EA/IA;IAAA;EA+IA;AAAA","sourcesContent":["@tailwind base;\n","@tailwind components;\n","@import 'tailwindcss/base';\n@import 'tailwindcss/components';\n@import 'tailwindcss/utilities';\n@import './colors.css';\n\n@layer base {\n  input,\n  textarea,\n  select {\n    @apply text-gray-900;\n  }\n\n  a {\n    @apply text-sky-800;\n  }\n\n  a:hover {\n    @apply text-sky-800 underline;\n  }\n}\n\n@layer components {\n  /* Override the blue set by @tailwindcss/forms */\n  .form-input:focus,\n  .form-textarea:focus,\n  .form-select:focus,\n  .form-multiselect:focus {\n    --tw-ring-color: var(--btn-primary-bg);\n    border-color: var(--btn-primary-bg);\n  }\n\n  .form-checkbox,\n  .form-radio {\n    color: var(--btn-primary-bg);\n  }\n\n  .form-checkbox:focus,\n  .form-radio:focus {\n    --tw-ring-color: var(--btn-primary-bg);\n  }\n\n  .bg-panel {\n    background-color: var(--panel-bg);\n    color: var(--panel-text);\n  }\n\n  .btn {\n    @apply inline-block p-2 font-bold shadow-md transition duration-150 ease-in-out;\n    background-color: var(--btn-primary-bg);\n    color: var(--btn-primary-text);\n    border-radius: var(--btn-border-radius);\n\n    &:hover,\n    &.hover {\n      background-color: var(--btn-primary-bg-hover);\n    }\n  }\n\n  .btn-secondary {\n    @apply btn;\n    background-color: var(--btn-secondary-bg);\n    color: var(--btn-secondary-text);\n\n    &:hover,\n    &.hover {\n      background-color: var(--btn-secondary-bg-hover);\n    }\n\n    &.active {\n      background-color: var(--btn-primary-bg);\n    }\n  }\n\n  .btn-rounded {\n    @apply rounded-full;\n  }\n\n  /* For the send button in ChatPanel */\n  .btn-in-input {\n    @apply text-gray-600;\n    &:hover {\n      color: var(--btn-primary-bg-hover);\n    }\n    &[disabled],\n    &[disabled]:hover {\n      @apply text-gray-600;\n    }\n  }\n\n  .animation-ping {\n    animation: ping 1s cubic-bezier(0, 0, 0.2, 1) infinite;\n  }\n\n  @keyframes ping {\n    75%,\n    100% {\n      transform: scale(2);\n      opacity: 0;\n    }\n  }\n\n  .counter {\n    @apply absolute -right-2 bottom-0 flex h-6 w-6 select-none items-center justify-center rounded-full border-2 border-gray-300 text-sm;\n    background-color: var(--btn-secondary-bg);\n    color: var(--btn-secondary-text);\n  }\n\n  .counter-red {\n    @apply counter border-red-600 bg-red-600 text-white;\n  }\n\n  .naf-centered-fullscreen {\n    @apply bg-panel absolute inset-0 z-10 flex flex-col items-center justify-center gap-2;\n  }\n\n  .naf-bar {\n    @apply pointer-events-none absolute z-10 flex w-full items-center gap-4 [&>*]:pointer-events-auto;\n  }\n\n  .naf-top-bar-left {\n    @apply naf-bar left-6 top-6 justify-start;\n  }\n\n  .naf-top-bar-center {\n    @apply naf-bar top-6 justify-center;\n  }\n\n  .naf-top-bar-right {\n    @apply naf-bar right-6 top-6 justify-end;\n  }\n\n  .naf-bottom-bar-left {\n    @apply naf-bar bottom-6 left-6 justify-start;\n  }\n\n  .naf-bottom-bar-center {\n    @apply naf-bar bottom-6 justify-center;\n  }\n\n  .naf-bottom-bar-right {\n    @apply naf-bar bottom-6 right-6 justify-end;\n  }\n}\n","@tailwind utilities;\n",":root {\n  --panel-bg: rgb(0 0 0); /* bg-slate-400 */\n  --panel-text: rgb(255 255 255); /* bg-neutral-800 */\n  --btn-primary-bg: rgb(85, 252, 39); /* bg-slate-600 */\n  --btn-primary-bg-hover: rgb(0 0 0); /* bg-slate-700 */\n  --btn-primary-text: rgb(100 100 100); /* text-slate-200 */\n  --btn-secondary-bg: rgb(38 38 38); /* bg-neutral-800 */\n  --btn-secondary-bg-hover: rgb(64 64 64); /* bg-neutral-600 */\n  --btn-secondary-text: rgb(255 255 255); /* text-slate-300 */\n  --btn-border-radius: 0.5rem; /* rounded-lg */\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
